import { gql } from "@apollo/client";

export const GET_PARSERLOGS = gql`
  query GetParserLogs($limit: Int, $organisationId: Int) {
    msgbox_EmailParserLog(
      limit: $limit
      order_by: { MessageArrived: desc }
      where: { OrganisationId: { _eq: $organisationId } }
    ) {
      EmailParserLogId
      MessageArrived
      OrganisationId
      OrganisationName
      ParserType
      EmailAddress
      TemplateMessageSent
      CustomerReplied
      EmailForwardedAt
      ErrorDetails
      S3Identifier
      InboxId
      InboxName
      ContactMobileMasked
      LeadSource
      SendStatus
      SendFailureReason
    }
  }
`;

export const GET_ORGANISATIONS = gql`
  query GetOrganisations {
    msgbox_Organisation(order_by: { Name: asc }) {
      OrganisationId
      Name
    }
  }
`;
